import React, { useMemo, useRef } from 'react';
import { useI18n } from '@oneaudi/i18n-context';
import { FilterHeadline, FilterOverlayNavigationMobile, FilterOverlayNavigationHeaderMobile, AccordionContainer, FilterOverlayNavigationDesktopContainer, FilterOverlayNavigationDesktop, FilterOverlayNavigationDesktopWrapper, FilterOverlayNavigationCategoriesDesktop, } from '../styles/FilterOverlay.styles';
import { SECTION, ANCHOR_MOBILE, OVERLAY_ANCHOR_DESKTOP } from './Filter';
import { useSelector } from 'react-redux';
import { SELECTORS } from '@oneaudi/stck-store';
import { FilterOverlayAccordion } from './FilterOverlayAccordion';
import { FilterOverlayAccordionSection } from './FilterOverlayAccordionSection';
import { useDesktopOrMobileView, useScsUrlParts } from '../../../hooks';
import { useServicesContext } from '../../../context';
import { trackClicks, trackRemoveAllFilters } from '../tracking';
import { EquipmentFilter } from './EquipmentFilter';
import { useCountSelectedFilters } from '../FilterContextHooks';
import { IconButton, Icon, Headline, NavigationBar, } from '@oneaudi/unified-web-components';
import { SYS_COLOR_SURFACE_NEUTRAL_300_DARK, SYS_SPACE_FIXED_150, SYS_SPACE_FIXED_300, SYS_SPACE_FIXED_400, ThemeProvider, } from '@oneaudi/unified-web-common';
import styled from 'styled-components';
import { DynamicComponent, DynamicThemeProviderWrapper } from '../../utils';
export const FilterOverlayNavigation = ({ configuredFilters, isFilterOverlayOpened, equipmentFilterCategories, overlayNavBarState, setOverlayNavBarState, overlayRef, clearAllFilters, closeOverlay, navigateToContentSection, renderFilters, }) => {
    const countSelectedFilters = useCountSelectedFilters();
    const trackingService = useServicesContext().getAdditionalService('audi-tracking-service');
    const { isUsedCarMkt } = useScsUrlParts();
    const navWrapperRef = useRef(null);
    const overlayHeadlineMobile = useI18n({
        id: `nemo.sc.filter.overlayHeadlineMobile`,
        defaultMessage: 'Filter',
    });
    const overlayHeadlineDesktop = useI18n({
        id: `nemo.sc.filter.overlayHeadlineDesktop`,
        defaultMessage: 'Filter',
    });
    const overlayCloseButtonAriaLabel = useI18n({
        id: `nemo.sc.filter.overlayCloseButtonAriaLabel`,
        defaultMessage: 'Close filter menu',
    });
    const overlayClearAllFiltersButtonAriaLabel = useI18n({
        id: `nemo.sc.filter.overlayClearAllFiltersButtonAriaLabel`,
        defaultMessage: 'Clear all filters',
    });
    const allSelectedFilters = useSelector((state) => SELECTORS.FILTERS.getSelectedFiltersMap(state));
    const totalResults = useSelector((state) => SELECTORS.VEHICLES.getTotalCountState(state));
    const isDesktopOrTablet = useDesktopOrMobileView('768px') === 'desktop';
    const handleCloseOverlay = () => {
        const trackingEventName = 'vtp filter - close filters - layer close';
        trackClicks(trackingService, trackingEventName, '', 'icon', '', false);
        closeOverlay();
    };
    const handleEraseButtonClick = () => {
        const trackingRelatedFilters = [];
        [...allSelectedFilters.values()].forEach((filter) => {
            const relatedFilter = { id: filter.id, values: filter.values || [] };
            trackingRelatedFilters.push(relatedFilter);
        });
        trackRemoveAllFilters(trackingService, 'vtp filter - remove all filter', 'icon', '', trackingRelatedFilters, totalResults, isUsedCarMkt);
        clearAllFilters();
    };
    const items = useMemo(() => {
        return configuredFilters.map((configuredCategory, index) => ({
            active: overlayNavBarState === `${SECTION}${index + 1}${OVERLAY_ANCHOR_DESKTOP}`,
            label: `${configuredCategory.filterCategory} ${countSelectedFilters.increment(configuredCategory).totalCount}`,
            onClick: () => {
                const sectionOverlayValue = `${SECTION}${index + 1}${OVERLAY_ANCHOR_DESKTOP}`;
                setOverlayNavBarState(sectionOverlayValue);
                navigateToContentSection(sectionOverlayValue);
            },
        }));
    }, [configuredFilters, overlayNavBarState]);
    return (React.createElement(React.Fragment, null, isDesktopOrTablet ? (React.createElement(FilterOverlayNavigationDesktopContainer, null,
        React.createElement(FilterOverlayNavigationDesktop, null,
            React.createElement(FilterOverlayNavigationDesktopWrapper, null,
                React.createElement(ThemeProvider, { theme: { name: 'dark' } },
                    React.createElement(FilterHeadline, null,
                        React.createElement(StyledIcon, { name: "filter", size: "s" }),
                        React.createElement(DynamicComponent, { legacy: React.createElement(StyledHeadline, { tag: "h2", variant: {
                                    order: '1',
                                    type: 'copy',
                                    weight: 'normal',
                                } }, overlayHeadlineDesktop) }),
                        React.createElement(DynamicComponent, { alpha: React.createElement(Headline, { tag: "h2", variant: {
                                    order: '4',
                                    type: 'headline',
                                    weight: 'normal',
                                } }, overlayHeadlineDesktop) }))),
                React.createElement(FilterOverlayNavigationCategoriesDesktop, null,
                    React.createElement(ThemeProvider, { theme: { name: 'dark' } },
                        React.createElement("div", { ref: navWrapperRef, onPointerDownCapture: (e) => {
                                e.preventDefault();
                            }, onFocusCapture: (e) => {
                                var _a;
                                if ((_a = navWrapperRef.current) === null || _a === void 0 ? void 0 : _a.contains(e.target)) {
                                    const activeItem = navWrapperRef.current.querySelector('button[tabindex="0"]');
                                    activeItem === null || activeItem === void 0 ? void 0 : activeItem.focus();
                                }
                            } },
                            React.createElement(NavigationBar, { id: "nav-bar-overlay__scrolling", size: "md", scrollButtons: {
                                    left: {
                                        ariaLabel: 'Scroll back',
                                    },
                                    right: {
                                        ariaLabel: 'Scroll forward',
                                    },
                                }, items: items, onKeyNavigate: (newIndex) => {
                                    const sectionOverlayValue = `${SECTION}${newIndex + 1}${OVERLAY_ANCHOR_DESKTOP}`;
                                    setOverlayNavBarState(sectionOverlayValue);
                                } }))))),
            React.createElement(IconButton, { variant: "tertiary", icon: "cancel", size: "md", onClick: handleCloseOverlay, "aria-label": overlayCloseButtonAriaLabel, "data-tracking-exclude": true })))) : (React.createElement(FilterOverlayNavigationMobile, null,
        React.createElement(FilterOverlayNavigationHeaderMobile, null,
            React.createElement(ThemeProvider, { theme: { name: 'dark' } },
                React.createElement(IconButton, { variant: "tertiary", icon: "back", size: "md", onClick: handleCloseOverlay, "aria-label": overlayCloseButtonAriaLabel, "data-tracking-exclude": true }),
                React.createElement(StyledHeadline2, { tag: "h2", variant: {
                        order: '4',
                        type: 'headline',
                        weight: 'bold',
                    } }, overlayHeadlineMobile),
                React.createElement(StyledIconButton, { variant: "tertiary", icon: "erase", size: "md", onClick: handleEraseButtonClick, "aria-label": overlayClearAllFiltersButtonAriaLabel, "data-tracking-exclude": true }))),
        React.createElement(AccordionContainer, { className: isFilterOverlayOpened ? 'active' : '' },
            React.createElement(DynamicThemeProviderWrapper, null,
                React.createElement(FilterOverlayAccordion, { isFilterOverlayOpened: isFilterOverlayOpened, overlayRef: overlayRef }, configuredFilters.map((configuredCategory, index) => {
                    if (configuredCategory.isEquipmentFilter && equipmentFilterCategories) {
                        return (React.createElement(FilterOverlayAccordionSection, { key: index, id: `${SECTION}${index + 1}${ANCHOR_MOBILE}`, label: `${configuredCategory.filterCategory} ${countSelectedFilters.increment(configuredCategory).totalCount}`, isLast: index === configuredFilters.length - 1 },
                            React.createElement(EquipmentFilter, { configFilterCategory: configuredCategory === null || configuredCategory === void 0 ? void 0 : configuredCategory.filterCategory, equipmentFilterCategories: equipmentFilterCategories, equipmentFilterCategoryLabel: configuredCategory.filterCategory, renderFilters: renderFilters, closeOverlay: closeOverlay, clearAllFilters: clearAllFilters })));
                    }
                    return (React.createElement(FilterOverlayAccordionSection, { key: index, id: `${SECTION}${index + 1}${ANCHOR_MOBILE}`, label: `${configuredCategory.filterCategory} ${countSelectedFilters.increment(configuredCategory).totalCount}`, isLast: index === configuredFilters.length - 1 }, renderFilters(configuredCategory, 'mobile')));
                }))))))));
};
export default FilterOverlayNavigation;
const StyledHeadline = styled((props) => React.createElement(Headline, Object.assign({}, props))) `
  margin-right: ${SYS_SPACE_FIXED_400};
  color: ${SYS_COLOR_SURFACE_NEUTRAL_300_DARK};
`;
const StyledIcon = styled((props) => React.createElement(Icon, Object.assign({}, props))) `
  margin-right: ${SYS_SPACE_FIXED_150};
  color: ${SYS_COLOR_SURFACE_NEUTRAL_300_DARK};
`;
const StyledIconButton = styled((props) => React.createElement(IconButton, Object.assign({}, props))) `
  margin-right: var(--spacing-relative-2xs);
`;
const StyledHeadline2 = styled((props) => React.createElement(Headline, Object.assign({}, props))) `
  margin-top: ${SYS_SPACE_FIXED_300} !important;
  margin-bottom: ${SYS_SPACE_FIXED_300} !important;
`;
